import React, { FC, ReactNode } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useAppDispatch, useAppSelector } from '@app/store/hooks'
import { removeAlert } from '@app/store/slices/alerts'
import Alert from './Alert'
import AlertStack from './AlertStack'

interface AlertProviderProps {
  children: ReactNode
}

const AlertProvider: FC<AlertProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch()
  const { items } = useAppSelector(store => store.alerts)

  return (
    <>
      {children}
      <AlertStack>
        <AnimatePresence>
          {items.map(item => (
            <Alert key={item.id} severity={item.variant} onClose={() => dispatch(removeAlert(item.id))}>
              {item.message}
            </Alert>
          ))}
        </AnimatePresence>
      </AlertStack>
    </>
  )
}

export default AlertProvider
